export default __webpack_public_path__ + "static/media/wi-snow.41a01da1.svg";